exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-ErrorMessage {\n  width: 100%; }\n  .a-ErrorMessage:empty {\n    margin: 0; }\n  .a-ErrorMessage:not(:empty) {\n    padding-top: 0.66667rem;\n    color: #ea0100; }\n", ""]);

// exports
